export enum EnumMenuPrincipalModo{
    PDV = 'PDV',
    Retaguarda = 'Retaguarda',
}
